export default __webpack_public_path__ + "img/caret-down-black.f5f9d2c2.svg";